import { Grid, Col } from '@koaly/grid';
import { rem, getVariantToken } from '@koaly/mixins';
import React from 'react';
import { up, down } from 'styled-breakpoints';
import styled, { css } from 'styled-components';
import { TitleContent } from '../TitleContent/TitleContent.js';

const StyledHero = styled(Grid).attrs({ forwardedAs: 'section' }) `
  ${up('s')} {
    ${({ appearance }) => appearance !== 'playful' && css `
      max-height: ${rem(560)};
    `}
    min-height: ${rem(400)};
  }
;
  text-align: ${getVariantToken('hero', 'textAlign')};

  ${down('xs')} {
    text-align: ${getVariantToken('hero', 'textAlignMobile')};
  }
;
  padding: ${({ theme }) => theme.tokens.contentSectionMobilePaddingVertical} 0;

  ${up('s')} {
    padding: ${({ theme }) => theme.tokens.contentSectionSpacingVertical} 0;
  }
`;
const StyledTitleContent = styled(TitleContent) `
  ${up('s')} {
    max-width: ${rem(430)};
  }
`;
const StyledMedia = styled.div `
  ${down('xs')} {
    width: auto;
    margin: ${rem(40)} auto 0 auto;
  }
`;
const StyledParagraphCol = styled(Col) `
  ${({ appearance }) => appearance === 'playful' && css `
    ${up('s')} {
      padding-bottom: 75px;
    }
  `};
`;
const Hero = ({ title, buttons, description, variant, appearance, media, children }) => {
    return (React.createElement(StyledHero, { gutter: 55, appearance: appearance },
        React.createElement(StyledParagraphCol, { width: { xs: 1, s: 1 / 2, l: 5 / 12 }, flex: true, valign: "center", appearance: appearance },
            React.createElement(StyledTitleContent, { buttons: buttons, variant: variant, title: title, titleSize: appearance === 'playful' ? 'mega' : 'h1', description: description }, children)),
        React.createElement(Col, { width: { xs: 1, s: 1 / 2, l: 7 / 12 }, flex: true, valign: "center" },
            React.createElement(StyledMedia, null, media))));
};

export { Hero };
//# sourceMappingURL=Hero.js.map
